export default __webpack_public_path__ + "static/media/slider9.b221075b.jpeg";